import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { type Team } from "./entity";

export const TeamEntityConfig: HyperEntityConfig<Team> = {
  allowApiRead: true,
  allowApiCrud: Roles.AdminsAndManager,
  apiPrefilterPerRole: (filter) => {
    if (!remult.user) return;

    filter(Roles.SuperDuperAdmin, true);

    filter([Roles.SuperAdmin, Roles.Admin], {
      organization: {
        $id: remult.user.organizationId,
      },
    });

    filter(Roles.Manager, {
      $or: [
        {
          isMainOrganizationTeam: true,
        },
        {
          managers: {
            $some: {
              managerId: remult.user.id,
            },
          },
        },
      ],
    });

    filter(Roles.User, {
      $or: [
        {
          organization: {
            $id: {
              $in: remult.user.organizations,
            },
          },
        },
        {
          isProject: true,
        },
      ],
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);
    allow([Roles.SuperAdmin, Roles.Admin], true);
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);

    allow([Roles.Admin, Roles.SuperAdmin], {
      organization: {
        $id: remult.user!.organizationId,
      },
    });

    allow(Roles.Manager, (entity) =>
      remult.user!.managingTeams!.includes(entity.id),
    );
  },
  __preventLogger: true, // Prevent development security logger from logging this entity
  defaultOrderBy: {
    isMainOrganizationTeam: "desc",
    name: "asc",
  },
};
